import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { __ANPR_PERSON_NEW_API_URL__ } from 'shell/constants/environment';
import { ItemVM } from 'shell/view-models/item';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseListPayloadQuarkus } from 'shell/models/http-response';
import { PmiFormControl } from '../pmi-select/pmi-form-control';
import { PmiSelect } from '../pmi-select';

interface ConsulateListComponentProps {
  disabled?: boolean;
  value: string;
  onChange?: (event: SelectChangeEvent<string>) => void;
  onChangeItem?: (value: ItemVM | undefined) => void;
  error?: boolean;
  label?: string;
  id?: string;
  onBootstrap?: boolean;
}

type Key = {
  codice: string;
};

interface ConsulateAnpr {
  key: Key;
  denomStatoEsteroConsolato: string;
  sedeConsolato: string;
}

const ConsulateListComponent = ({
  disabled,
  onChange,
  onChangeItem,
  value,
  error,
  label = 'Consolato',
  id = 'consulate',
  onBootstrap = true,
}: ConsulateListComponentProps): React.ReactElement => {
  const [consulateList] = useHttpFetch<
    HttpResponseListPayloadQuarkus<ConsulateAnpr>,
    Array<ItemVM>
  >(`${__ANPR_PERSON_NEW_API_URL__}/consolati`, {
    options: {
      method: 'GET',
      abortable: true,
      errorCatching: false,
      loading: false,
    },
    onBootstrap,
    transformer: (response) => {
      return response.data.payload?.map((item) => ({
        id: item.key.codice,
        value: `${item.sedeConsolato} - ${item.denomStatoEsteroConsolato}`,
      }));
    },
  });

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={`${id}-label`}>
        {label}
      </InputLabel>
      <PmiSelect
        labelId={`${id}-label`}
        id={id}
        name={id}
        value={value}
        label={label}
        onChange={(event) => {
          const selectedValue = event.target.value;
          if (onChangeItem) {
            const foundElement = (consulateList?.data as Array<ItemVM>).find(
              (item) => item.id === selectedValue
            );
            onChangeItem(foundElement);
            return;
          }
          if (onChange) {
            onChange(event);
          }
        }}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {consulateList?.data
          ? (consulateList?.data as Array<ItemVM>).map((item: ItemVM) => (
              <MenuItem key={item.id} value={item.id}>
                {item.value}
              </MenuItem>
            ))
          : undefined}
      </PmiSelect>
    </PmiFormControl>
  );
};

ConsulateListComponent.displayName = 'Consulate list anpr component';

const ConsulateList = memo(ConsulateListComponent);

export default ConsulateList as typeof ConsulateListComponent;
